import * as React from 'react';

import type {CoreEntityType} from 'nutshell-core/types';

import {colors} from 'shells/colors/colors';
import {ErrorState} from 'shells/error-state/error-state';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {Modal as ModalComponent} from 'shells/modal/modal';

import type {LogActivityInput} from 'nutshell-graphql-types';

import {useGetActivity} from '../../../activity-ai/graphql/hooks/use-get-activity';
import {useOpenableModal, OpenableModals} from '../../../openable-modals';
import {useLogActivity} from '../../../timeline/creator/graphql/hooks/use-log-activity';

import {ActivityLogModalContent} from './activity-log-modal-content';

import styles from './activity-log-modal.module.css';

export type Props = {
    activityId: string;
    entityType?: CoreEntityType;
    onLogActivity?: () => Promise<any>;
};

export function ActivityLogModal(props: Props) {
    const [isFeatureGateModalOpen, setIsFeatureGateModalOpen] = React.useState(false);

    const {activity, isLoading, errorMessage} = useGetActivity(props.activityId);
    const {logActivity, isLoading: isLogging} = useLogActivity();
    const {onClose} = useOpenableModal(OpenableModals.ACTIVITY_LOG_MODAL);

    const handleLogActivity = (input: LogActivityInput) => {
        return logActivity(input).then(() => {
            props.onLogActivity?.();
            $(window).trigger(Timeline.events.TimelineRefresh);
            Activity.refreshActivities(parseInt(props.activityId));

            if (props.entityType === 'leads') {
                // We need to update the lead stage if the created activity meets
                // an automated stage goal
                $(window).trigger(Lead.events.LeadBackboneModelDidUpdate);
            }
        });
    };

    let modalContent;
    if (isLoading) {
        modalContent = (
            <div className={styles['loading-container']}>
                <LoadingIcon size={32} fill={colors.orange} />
            </div>
        );
    } else if (errorMessage || !activity) {
        modalContent = <ErrorState errorMessage={errorMessage} size='small' />;
    } else {
        modalContent = (
            <ActivityLogModalContent
                activity={activity}
                onClose={onClose}
                onLogActivity={handleLogActivity}
                isLogging={isLogging}
                isFeatureGateModalOpen={isFeatureGateModalOpen}
                setIsFeatureGateModalOpen={setIsFeatureGateModalOpen}
            />
        );
    }

    return (
        <ModalComponent
            isOpen={true}
            onClose={onClose}
            isCentered={true}
            maxWidth={570}
            maxHeight={650}
            closeButton={false}
            canEscapeToClose={!isFeatureGateModalOpen}
            fitHeight={true}
            noPadding={true}
        >
            {modalContent}
        </ModalComponent>
    );
}
